import type { CheckoutShippingZone } from "../models/CheckoutSettings";

function normalizeCountryCode(raw: string | undefined | null): string {
  if (raw == null) return "";
  return String(raw).trim().toUpperCase();
}

export function getShippingForCountry({
  country,
  shippingZones,
}: {
  country: string | undefined | null;
  shippingZones: CheckoutShippingZone[] | undefined | null;
}): { cents: number; label: string } {
  const code = normalizeCountryCode(country);
  if (!code) {
    return { cents: 0, label: "" };
  }
  const zones = shippingZones ?? [];
  if (zones.length === 0) {
    return { cents: 0, label: "" };
  }

  const normList = (list: string[]) =>
    list.map((c) => normalizeCountryCode(c)).filter(Boolean);

  let matched: CheckoutShippingZone | undefined;
  for (const z of zones) {
    const countries = normList(z.countries ?? []);
    if (countries.length > 0 && countries.includes(code)) {
      matched = z;
      break;
    }
  }
  if (!matched) {
    for (const z of zones) {
      const countries = z.countries ?? [];
      if (countries.length === 0) {
        matched = z;
        break;
      }
    }
  }

  if (!matched) {
    return { cents: 0, label: "" };
  }

  const option = matched.prices?.[0];
  if (!option || !Number.isFinite(option.price)) {
    return { cents: 0, label: "" };
  }

  const cents = Math.max(0, Math.round(option.price));
  const label = `${matched.name}: ${option.name}`;
  return { cents, label };
}
